
import { defineComponent, ref, Ref } from "vue";
import { FindPassword1Params, UserService } from "@/utils/api/user";
import { ElMessage } from 'element-plus';

export default defineComponent({
  props: {
    phoneNumber: String
  },
  setup(props, context) {
    const information: Ref<FindPassword1Params> = ref({
      username: "",
      ID: "",
    });
    const form = ref(null);
    const submitForm = () => {
      let flag;
     (form.value as any).validate((valid: boolean) => {
        flag = valid;
      });
      if (flag === true) {
        UserService.findPassword1(information.value)
          .then((res) => {
            console.log(res.data);
            if (res.data.a == 21) {
              context.emit('next1');
              context.emit('update:phoneNumber',res.data.b);
            } else if (res.data.a ==  20) {
              openError('该用户不存在！');
            } else {
              openError('出错了，请联系管理员！')
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };
    const checkUsername = (rule: any, value: any, callback: any) => {
      if (!value) {
        return callback(new Error("姓名不能为空"));
      }
      let r =/^[\u4E00-\u9FFF]{2,6}$/;
      if (!r.test(value)) {
        return callback(new Error("姓名应该为2到6个汉字"));
      }
      callback();
    };
    const checkID = (rule: any, value: any, callback: any) => {
      if (!value) {
        return callback(new Error("身份证号不能为空"));
      }
      let r =/^\d{18}$/;
      if (!r.test(value)) {
        return callback(new Error("身份证号应该为18位数字"));
      }
      callback();
    };

    const rules = {
      username: [{ validator: checkUsername, trigger: "submit" }],
      ID: [{ validator: checkID, trigger: "submit" }],
    };
    const openError= (inf: string) => {
          ElMessage({
            showClose: true,
            message: inf,
            type: 'error',
            offset: 200,
          });
    };  
    return {
      form,
      submitForm,
      information,
      rules,
      openError,
    };
  },
});
